import React from 'react';
import styled from 'styled-components';
import Hero from '../components/Hero/Hero';

const HomeContainer = styled.div`
  width: 100%;
  margin: 0 auto;
`;

const Home = () => {
  return (
    <HomeContainer>
      <Hero />
    </HomeContainer>
  );
};

export default Home;